import React from 'react'
import { space } from '@entur/tokens'
import { Modal } from '@entur/modal'
import { Paragraph } from '@entur/typography'
import { NegativeButton, SecondaryButton } from '@entur/button'

type DeleteModalProps = {
  open: boolean
  title: string
  description: string
  negativeText: string
  positiveText: string
  action: () => void
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  open,
  title,
  description,
  negativeText,
  positiveText,
  action,
  setOpen,
}) => {
  return (
    <Modal open={open} onDismiss={() => setOpen(false)} title={title} size="medium">
      <Paragraph>{description}</Paragraph>
      <NegativeButton
        style={{ marginRight: space.small }}
        data-cy="delete-modal-negative-button"
        onClick={() => {
          setOpen(false)
          action()
        }}
      >
        {negativeText}
      </NegativeButton>
      <SecondaryButton data-cy="delete-modal-positive-button" onClick={() => setOpen(false)}>
        {positiveText}
      </SecondaryButton>
    </Modal>
  )
}

export default DeleteModal
